import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Login from './Login';
import RegistrarUsuario from './RegistrarUsuario';
import './Login.css';
import { clearSession, isTokenExpired } from '../services/sessionUtils';

export default function Inicio() {
  const location = useLocation();
  const navigate = useNavigate();
  const [vista, setVista] = useState('inicio');
  const sesionExpirada = new URLSearchParams(location.search).get('sesion') === 'expirada';

  useEffect(() => {
    if (location.state?.mostrarLogin || sesionExpirada) setVista('login');
  }, [location.state, sesionExpirada]);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token && !isTokenExpired(token)) navigate('/dashboard/admin', { replace: true });
    else if (token) {
      clearSession();
      setVista('login');
    }
  }, [navigate]);

  return (
    <main className={`auth-scene auth-scene--${vista}`}>
      {sesionExpirada && (
        <div className="auth-session-notice" role="alert" aria-live="assertive">
          <span aria-hidden="true">!</span>
          Tu sesión terminó por seguridad. Ingresa nuevamente para continuar.
        </div>
      )}

      <section className="auth-brand" aria-label="Acuapetén Peces del Itzá">
        <div className="auth-brand__glow" aria-hidden="true" />
        {vista === 'inicio' && (
          <div className="auth-home-art" aria-hidden="true">
            <span className="auth-home-art__ring auth-home-art__ring--one" />
            <span className="auth-home-art__ring auth-home-art__ring--two" />
            <span className="auth-home-art__current auth-home-art__current--one" />
            <span className="auth-home-art__current auth-home-art__current--two" />
          </div>
        )}
        <div className="auth-brand__content">
          {vista === 'inicio' ? (
            <div className="auth-home-badge"><span /> Tecnología para una acuicultura inteligente</div>
          ) : (
            <p className="auth-brand__eyebrow">Piscicultura inteligente</p>
          )}
          <h1 className="titulo-gel">CONTROL DE ESTANQUES</h1>
          <div className="auth-logo-stage">
            <span className="auth-logo-stage__halo" aria-hidden="true" />
            <span className="auth-logo-stage__shine" aria-hidden="true" />
            <img src="/Logo_peces.png" alt="Acuapetén Peces del Itzá" className="auth-brand__logo" />
          </div>
          <p className="auth-brand__description">
            ESTE ES TU SISTEMA FAVORITO PARA LA AUTOMATIZACIÓN<br />
            DEL MONITOREO DE TUS ESTANQUES DE PECES
          </p>
          {vista === 'inicio' && (
            <>
            <p className="auth-home-promise">Conecta <span>·</span> Comprende <span>·</span> Protege</p>
            <div className="auth-home-capabilities" aria-label="Capacidades principales">
              <div><span className="auth-capability-icon">◉</span><strong>Monitoreo</strong><small>Datos en tiempo real</small></div>
              <div><span className="auth-capability-icon">⌁</span><strong>Automatización</strong><small>Control inteligente</small></div>
              <div><span className="auth-capability-icon">◇</span><strong>Seguridad</strong><small>Acceso protegido</small></div>
            </div>
            </>
          )}
        </div>
      </section>

      {vista !== 'inicio' && (
        <section className="auth-form-panel" aria-label={vista === 'login' ? 'Inicio de sesión' : 'Registro'}>
          <div className="auth-form-scroll" key={vista}>
            {vista === 'login' ? <Login /> : <RegistrarUsuario setVista={setVista} />}
          </div>
        </section>
      )}

      <nav className="auth-switcher" aria-label="Opciones de acceso">
        {vista !== 'login' && <button type="button" onClick={() => setVista('login')}>Ingresar</button>}
        {vista !== 'registro' && <button type="button" onClick={() => setVista('registro')}>Registrarse</button>}
      </nav>

      {vista === 'inicio' && (
        <footer className="auth-home-footer">
          <span className="auth-system-status"><i /> Sistema disponible</span>
          <span>Monitoreo · Automatización · IoT</span>
        </footer>
      )}
    </main>
  );
}
